import { createAction, props } from '@ngrx/store';
import { ConfirmationMetadata } from './confirmation-metadata';

export const showConfirmation = createAction(
  '[Confirmation] Show Confirmation',
  props<{ metadata: ConfirmationMetadata }>()
);

export const confirmationAccepted = createAction(
  '[Confirmation] Confirmation Accepted',
  props<{ key?: string; data?: any }>()
);

export const confirmationRejected = createAction(
  '[Confirmation] Confirmation Rejected',
  props<{ key?: string; data?: any }>()
);
